import { useRef } from 'react';
import { useEventListener } from 'ahooks';

const useTextCounter = props => {
  const { length, maxLength, disabled } = props;
  const ref = useRef(null);
  const spanRef = useRef(null);

  const handleInput = event => {
    const length = event.currentTarget.value.length;
    spanRef.current.textContent = length;
  };

  useEventListener('input', handleInput, { target: ref });

  const renderTextCounter = (props = {}) => {
    const { className } = props;
    return (
      <div className={['leading-none select-none', 'text-14px', className]}>
        <span
          ref={spanRef}
          className={['text-[#999]', { 'text-[#999]': disabled }]}
        >
          {length}
        </span>
        <span className="text-[#999]">/{maxLength}</span>
      </div>
    );
  };

  return [ref, renderTextCounter];
};

export default useTextCounter;
